import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemRemove',
  emits: ["remove"],
  setup(__props, { emit }: { emit: ({(e: "remove"): void}), expose: any, slots: any, attrs: any }) {



function removeFromBasket() {
    emit("remove");
}

return { __sfc: true,emit, removeFromBasket }
}

})